export enum role {
    GENERALIST = "generalist",
    SPECIALIST = "specialist",
    NURSE = "nurse",
    HOST = "hostess",
  }
  export enum roleId {
    ADMIN = 1,
    GENERALIST = 5,
    SPECIALIST = 6,
    HOST = 3,
    NURSE = 4,
    STUFF = 2,
    STATION = 7,
  }